export default "__VITE_ASSET__cf86b6b3__"